import { BaseQueryFn } from "@reduxjs/toolkit/query";
import { AxiosRequestConfig, AxiosError } from "axios";

import { SnackbarKeys } from "@sso/constant";
import { apiInstance } from "@sso/services/baseHttp";
import { logOutUser } from "@sso/store/slices/auth";
import { pushSnackbar } from "@sso/store/slices/snackbar";
import { ApiErrors } from "@sso/types";
import { errorHandling } from "@sso/utils";

export const axiosBaseQuery =
  (): BaseQueryFn<AxiosRequestConfig, unknown, unknown> =>
  async ({ url, method, data, params }, { dispatch }) => {
    try {
      const result = await apiInstance.request({ url, method, data, params });
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError as AxiosError<ApiErrors>;

      const { msg, isUnAuthorized, isWarning } = errorHandling(err, url);

      if (isUnAuthorized) {
        dispatch(logOutUser());
      }
      if(isWarning)
      {
        dispatch(pushSnackbar({ type: SnackbarKeys.WARNING, title: msg }));
      }
      else{
        dispatch(pushSnackbar({ type: SnackbarKeys.ERROR, title: msg }));
      }
      
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };
